@use '../../styles/button' as button;
@use '../../styles/icon' as icon;
@use '../../styles/mixins' as mixins;
@use '../../styles/text' as text;
@use '../../styles/typography' as typography;

.navItem {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
  padding: 5px 8px;
  border: none;
  border-radius: 8px;
  background-color: transparent;
  text-decoration: none;
  cursor: pointer;
  transition: background-color 120ms ease;

  &:hover:not(:disabled) {
    background-color: button.$button-clear-hover;
  }

  &:focus-visible {
    @include mixins.focus-ring;
    outline-offset: -2px;
  }

  &:disabled {
    @include mixins.disabled(0.5);
  }
}

.selected {
  background-color: button.$button-clear-active;

  .label {
    color: text.$text-primary;
  }

  .icon,
  .caret {
    color: icon.$icon-primary;
  }
}

.icon {
  display: inline-flex;
  flex-shrink: 0;
  color: icon.$icon-secondary;
}

.label {
  @include typography.text-s-medium;
  padding: 0 2px;
  color: text.$text-secondary;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}

.caret {
  flex-shrink: 0;
  color: icon.$icon-secondary;
}
